import React from "react";
import { Box, Button } from "@mui/material";
import type { RootReducerType } from "@store/store";
import { useSelector, useDispatch } from "react-redux";
import ScrollToTopButton from "../../../../src/utils/scrollToTopButton";

export const StepsButton: React.FC<{
  onNext: () => void;
  onBack: () => void;
  nextDisabled?: boolean;
}> = ({ onNext, onBack, nextDisabled = false }) => {
  const { activeStep } = useSelector((state: RootReducerType) => state.stepper);
  const steps = [
    { label: "Utility & Location Details" },
    { label: "Site & Highways Information" },
    { label: "Upload Documents" },
    { label: "Payment" }
  ];
  return (
    <Box className="button-group px-6" sx={{ position: "relative" }}>
      <Button
        onClick={() => onBack()}
        variant="outlined"
        className="back-btn"
        sx={{
          backgroundColor: nextDisabled ? "#9E9E9E" : "#3A1C73",
          fontSize: "14px",
          padding: "3px 16px !important",
        }}
      >
        Back
      </Button>

      <Button
        onClick={() => onNext()}
        variant="contained"
        className="stepper-next-btn"
        disabled={nextDisabled}
        sx={{
          backgroundColor: nextDisabled ? "#9E9E9E" : "#3A1C73",
          fontSize: "14px",
          padding: "4px 16px",
          color: "#fff",
          "&.Mui-disabled": {
            backgroundColor: "#9E9E9E !important",
            color: "#fff !important"
          },
          "&:hover": {
            backgroundColor: nextDisabled ? "#9E9E9E" : "#2E1458"
          }
        }}
      >
        {activeStep === steps.length - 1 ? "Submit Application" : "Next"}
      </Button>
      <Box>
        <ScrollToTopButton />
      </Box>
    </Box>
  );
};
